
<div class = "container">
  <h3>{{system?.title}}</h3>
  <div class= "lineInfo">
    @if (showImage) {
      <div class="image">
        <img src="{{imageUrl}}" alt="" defaultImg>
      </div>
    }
    <div [innerHTML]="system[descriptionFieldName]" id="tinymce">
    </div>
  </div>
</div>
@if (button) {
  <button mat-raised-button color="primary" (click)="close()" matRipple>
    {{ 'INTERFACE|Wybierz' | translate }}
  </button>
}
